import { useEffect, useState, useRef, useCallback } from "react";
import { Helmet } from "react-helmet-async";
import { GrPowerReset } from "react-icons/gr";

function ResetIconBtn({ onClick, size = 16, topOffset = "12px" }) {
  const [hover, setHover] = useState(false);

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      aria-label="Clear"
      style={{
        position: "absolute",
        right: "8px",
        top: "50%",
        transform: "translateY(-50%)",
        background: "transparent",
        border: "none",
        cursor: "pointer",
        fontSize: `${size}px`,
        color: hover ? "#333" : "#999",
        padding: 0,
        width: `${size}px`,
        height: `${size}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: topOffset,
        transition: "color 0.2s ease-in-out",
      }}
    >
      <GrPowerReset style={{ pointerEvents: "none" }} />
    </button>
  );
}

function useDebounce(callback, delay) {
  const timer = useRef();
  return (...args) => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      callback(...args);
    }, delay);
  };
}

export default function DifferenceDashboard() {
  const API_URL = process.env.REACT_APP_API_URL;

  const [data, setData] = useState([]);
  const [totalRetailers, setTotalRetailers] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 20;

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page,
        pageSize: pageSize,
      });
      if (search) params.append("search", search);

      const response = await fetch(`${API_URL}retailers/weekly-winners-dashboard?${params.toString()}`);
      const result = await response.json();

      if (result.status === "success" && result.data) {
        setData(result.data.retailers || []);
        setTotalRetailers(result.data.pagination?.totalRetailers || 0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, [search, page, API_URL]);

  const debouncedFetchData = useDebounce(fetchData, 500);

  useEffect(() => {
    setPage(1);
  }, [search]);

  useEffect(() => {
    setLoading(true);
    debouncedFetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, page]);

  const totalPages = Math.ceil(totalRetailers / pageSize);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="admin-dashboard">
        <div style={{ padding: "20px", maxWidth: "1400px", margin: "0 auto" }}>
          <h1 style={{ color: "white", marginBottom: "20px", fontSize: "24px" }}>
            Difference Dashboard
          </h1>

          {/* <div
            style={{
              marginBottom: "20px",
              fontWeight: "bold",
            }}
            className="wrapper-top-titles"
          >
            <div
              style={{
                boxShadow: "0 0 3px rgba(0,0,0,0.1)",
                display: "inline-block",
                minWidth: "60px",
                textAlign: "center",
              }}
              className="title-retailers"
            >
              Total Retailers: <span className="white-box">{totalRetailers}</span>
            </div>
          </div> */}

          <div
            style={{
              marginBottom: "20px",
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              alignItems: "end",
            }}
          >
            <div style={{ flex: 1, position: "relative" }}>
              <label
                style={{ display: "block", marginBottom: "5px", fontSize: "14px" }}
              ></label>
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search retailers..."
                style={{
                  padding: "8px 32px 8px 8px",
                  width: "100%",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  marginBottom: 0,
                  height: 36,
                }}
              />
              {search && (
                <ResetIconBtn
                  onClick={() => setSearch("")}
                  size={16}
                  topOffset="0px"
                />
              )}
            </div>
          </div>

          {loading ? (
            <p style={{ color: "white" }}>Loading...</p>
          ) : (
            <>
              <div style={{ overflowX: "auto" }} className="bg-main-table">
                <table
                  className="admin-table"
                  style={{ width: "100%", borderCollapse: "collapse", color: "white" }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          color: "white",
                        }}
                      >
                        Retailer Code
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          color: "white",
                        }}
                      >
                        Retailer Name
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          color: "white",
                        }}
                      >
                        Mobile Number
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          color: "white",
                        }}
                      >
                        Week 1
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          color: "white",
                        }}
                      >
                        Week 2 Wrong
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          color: "white",
                        }}
                      >
                        Week 2 Right
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          color: "white",
                        }}
                      >
                        Difference
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          color: "white",
                        }}
                      >
                        Week 3
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          color: "white",
                        }}
                      >
                        Total Entries
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.length > 0 ? (
                      data.map((item, index) => (
                        <tr key={item.retailerId || index}>
                          <td style={{ padding: "12px" }}>{item.retailerCode || "-"}</td>
                          <td style={{ padding: "12px" }}>{item.retailerName || "-"}</td>
                          <td style={{ padding: "12px" }}>{item.mobileNumber}</td>
                          <td style={{ padding: "12px" }}>{item.week1 || 0}</td>
                          <td style={{ padding: "12px" }}>{item.week2Wrong || 0}</td>
                          <td style={{ padding: "12px" }}>{item.week2Right || 0}</td>
                          <td style={{ padding: "12px" }}>{item.difference || 0}</td>
                          <td style={{ padding: "12px" }}>{item.week3 || 0}</td>
                          <td style={{ padding: "12px" }}>{item.totalEntries || 0}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="9"
                          style={{
                            padding: "20px",
                            textAlign: "center",
                            color: "white",
                          }}
                        >
                          No retailers found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="pagination">
                <div className="pagination__controls">
                  <a
                    onClick={() => setPage(page - 1)}
                    disabled={page === 1}
                    className={`pagination__button ${page === 1 ? "pagination__button--disabled" : ""}`}
                  >
                    Previous
                  </a>
                  <span className="pagination__info">
                    Page {page} of {totalPages || 1}
                  </span>
                  <a
                    onClick={() => setPage(page + 1)}
                    disabled={page >= totalPages}
                    className={`pagination__button ${page >= totalPages ? "pagination__button--disabled" : ""}`}
                  >
                    Next
                  </a>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
